// import dailyInspectList from '../components/dailyInspect/dailyInspectList.vue'
// import addDaily from '../components/dailyInspect/addDaily.vue'

export default [
    {
        path: 'dailyInspect/dailyInspectList',
        component: resolve => require(['@/components/dailyInspect/dailyInspectList'],resolve),
        name: "DailyInspectList",
        meta:{
            id: '969',
            node: 'dailyInspect',
            url: 'dailyInspectList',
        }
    },
    {
        path: 'dailyInspect/addDaily',
        component: resolve => require(['@/components/dailyInspect/addDaily'],resolve),
        name: "AddDaily",
        meta:{
            id: '970',
            node: 'dailyInspect',
            url: 'addDaily',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/dailyInspect.js